import {
  App,
  Button
} from "antd";
import secureLocalStorage from "react-secure-storage";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppointmentType } from "../../types/user";
import classes from "./appointment.module.css";
import { appRoutes } from "../../constants/routes";
import useVideo from "../../hooks/useVideo";
import useCurrentUser from "../../hooks/useCurrentUser";

const AppointmentButton = ({ appointment, onClick }: {
  appointment: AppointmentType,
  onClick?: () => void
}) => {
  const { t } = useTranslation();
  const { message, modal } = App.useApp();
  const { fetchRoom } = useVideo();
  const navigate = useNavigate();
  const {
    isDoctor, isPatientApproved, finishedAppointmentWithCurrentDoctor
  } = useCurrentUser();
  const [loading, setLoading] = useState(false);

  const isMeetingStarted = (date: string) => {
    return dayjs(date).diff(dayjs(), "minute") < 5;
  };

  const canModifyMeeting = (date: string) => {
    return dayjs(date).diff(dayjs(), "hours") < 24;
  };

  const handleUserClick = () => {
    return isDoctor ? navigate(appRoutes.appointmentEdit, {
      state: {
        appointment
      }
    }) : onClick!();
  };

  const handleClick = () => {
    if (
      !isPatientApproved
      && !isDoctor
      && (finishedAppointmentWithCurrentDoctor !== 0 || finishedAppointmentWithCurrentDoctor > 1)
    ) {
      modal.info({
        title: t("global.sidebar.agreementLabel"),
        content: t("global.sidebar.onboardingText")
      });

      return null;
    }

    if (isMeetingStarted(appointment.start_at)) {
      setLoading(true);
      return fetchRoom(Number(appointment.id))
        .then(() => {
          secureLocalStorage.setItem("appointmentId", Number(appointment.id));
          navigate(appRoutes.video, {
            state: {
              appointment
            }
          });
        }).catch((err) => {
          setLoading(false);
          message.error(err);
        });
    }
    return handleUserClick();
  };

  return (
    <Button
      type="primary"
      block
      className={classes.button}
      loading={loading}
      disabled={(canModifyMeeting(appointment.start_at)
        && !isMeetingStarted(appointment.start_at)) || loading}
      onClick={() => {
        handleClick();
      }}
    >
      {isMeetingStarted(appointment.start_at)
        ? t("appointment.button.videoCall") : t("appointment.button.edit")}
    </Button>
  );
};

export default AppointmentButton;
